import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_pairingSetIdAdapter204jlhkjchobz as get_pairingSetIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeletePairAssignmentsInput11fmeg9pssfu8 as DeletePairAssignmentsInput } from '../DeletePairAssignmentsInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePairAssignmentsInput_InputAdapterClass;
function DeletePairAssignmentsInput_InputAdapter() {
  if (DeletePairAssignmentsInput_InputAdapterClass === VOID) {
    class $ {
      o3z(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      g6p(writer, customScalarAdapters, value) {
        writer.r47('partyId');
        get_partyIdAdapter().p3z(writer, customScalarAdapters, value.m6m_1);
        writer.r47('pairingSetId');
        get_pairingSetIdAdapter().p3z(writer, customScalarAdapters, value.n6m_1);
      }
      p3z(writer, customScalarAdapters, value) {
        return this.g6p(writer, customScalarAdapters, value instanceof DeletePairAssignmentsInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DeletePairAssignmentsInput_InputAdapter', VOID, VOID, [Adapter()]);
    DeletePairAssignmentsInput_InputAdapterClass = $;
  }
  return DeletePairAssignmentsInput_InputAdapterClass;
}
var DeletePairAssignmentsInput_InputAdapter_instance;
function DeletePairAssignmentsInput_InputAdapter_getInstance() {
  return DeletePairAssignmentsInput_InputAdapter_instance;
}
//region block: init
DeletePairAssignmentsInput_InputAdapter_instance = new (DeletePairAssignmentsInput_InputAdapter())();
//endregion
//region block: exports
export {
  DeletePairAssignmentsInput_InputAdapter_instance as DeletePairAssignmentsInput_InputAdapter_instanceni5oq19qlp68,
};
//endregion

//# sourceMappingURL=DeletePairAssignmentsInput_InputAdapter.mjs.map
